"use memo"

import { AgxButton, AgxSpacer } from '@urbanx/agx.ui-components2'

interface TaskModalActionButtonsProps {
  currentPage: number
  totalPages: number
  onPrevious: () => void | Promise<void>
  onNext: () => void | Promise<void>
  onComplete: () => void | Promise<void>
  onSaveAndExit: () => void | Promise<void>
  completeDisabled?: boolean
  saveAndExitDisabled?: boolean
  isSaving?: boolean
}

const TaskModalActionButtons = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  onComplete,
  onSaveAndExit,
  completeDisabled = false,
  saveAndExitDisabled = false,
  isSaving = false,
}: TaskModalActionButtonsProps) => {
  const showPreviousButton = currentPage !== 0
  const showNextButton = currentPage !== totalPages - 1
  const showCompleteButton = currentPage === totalPages - 1

  return (
    <AgxSpacer
      direction="horizontal"
      fill
      contentJustification="space-between"
      contentAlignment="center"
      gap="xs"
    >
      <AgxButton
        id={'complianceModal-saveAndExit'}
        text={'Save & Exit'}
        variant={'hollow'}
        onClick={onSaveAndExit}
        disabled={saveAndExitDisabled || isSaving}
      />
      <AgxSpacer
        direction="horizontal"
        gap="xs"
        contentJustification="end"
        contentAlignment="center"
      >
        {showPreviousButton && (
          <AgxButton
            id={'complianceModal-previous'}
            text={'Back'}
            variant={'hollow'}
            onClick={onPrevious}
            disabled={isSaving}
          />
        )}
        {showNextButton && (
          <AgxButton
            id={'complianceModal-next'}
            text={'Next'}
            variant={'primary'}
            onClick={onNext}
            disabled={isSaving}
          />
        )}
        {showCompleteButton && (
          <AgxButton
            id={'complianceModal-complete'}
            text={'Complete'}
            variant={'primary'}
            onClick={onComplete}
            disabled={completeDisabled || isSaving}
          />
        )}
      </AgxSpacer>
    </AgxSpacer>
  )
}

export default TaskModalActionButtons
